import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { QuoteForm } from "@/components/site/QuoteForm";
import { SERVICES, PHONE_DISPLAY, PHONE_HREF } from "@/components/site/data";

export const ServiceQuote = ({ content, preselect }) => (
  <section id="quote" data-testid="service-quote-section" className="bg-brand-surface/50 py-20 lg:py-24">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
      <div className="lg:pt-6">
        <p className="eyebrow">Request a Quote</p>
        <h2 className="h2 mt-5">Request a {content.short} Quote</h2>
        <p className="lead mt-4 max-w-md">Tell us a little about your space and what you need. We'll follow up with clear, no-pressure advice and a plan that fits your business.</p>
        <a href={PHONE_HREF} data-testid="service-quote-call-button" className="btn-secondary mt-8">
          <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
        </a>
      </div>
      <QuoteForm preselect={preselect} />
    </div>
  </section>
);

export const OtherServices = ({ currentId }) => (
  <section data-testid="other-services-section" className="bg-white py-16 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <h2 className="font-heading text-2xl font-semibold tracking-tight text-brand-navy">Other Services</h2>
      <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {SERVICES.filter((s) => s.id !== currentId).map(({ id, slug, title, icon: Icon }) => (
          <li key={id}>
            <Link to={`/services/${slug}`} data-testid={`other-service-link-${id}`} className="soft-card group flex h-full flex-col justify-between gap-5 p-5 transition-[transform,box-shadow,border-color] duration-300 hover:border-brand-blue/30 hover:shadow-md">
              <Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
              <span className="font-heading text-sm font-semibold leading-snug text-brand-navy">{title}</span>
              <span className="link-arrow text-xs">View service <ArrowRight className="h-3.5 w-3.5" /></span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
